import {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';
import {transactionsActions} from '..';
import useIsMountedRef from '../../../common/hooks/useIsMountedRef';
import {ITransaction} from '../../../types/diplomat/transaction/Transaction';

const actionsMap = {
   pgp: transactionsActions.getRefsPgp,
   ssh: transactionsActions.getRefsSsh,
   ssl: transactionsActions.getRefsSsl,
   proxy: transactionsActions.getRefsProxy,
   partner: transactionsActions.getRefsPartner,
   transaction: transactionsActions.getRefsTransaction,
};

export const useTransactionsRefs = (
   id: string,
   type: 'pgp' | 'ssh' | 'ssl' | 'proxy' | 'partner' | 'transaction'
) => {
   const isMountedRef = useIsMountedRef();
   const dispatch = useDispatch();
   const [transactions, setTransactions] = useState<ITransaction[]>([]);
   useEffect(() => {
      const action = actionsMap[type];
      dispatch(
         action(id, {
            onSuccess: (_transactions: ITransaction[]) => {
               if (isMountedRef.current) {
                  setTransactions(_transactions);
               }
            },
         })
      );
   }, [dispatch, id, isMountedRef, type]);

   return transactions;
};
